import React from 'react'

import { selectProjectById } from '../api/for-company/projects.api'
import { ForProjectRole } from '../components/Auth/ForProjectRole'
import { ToolbarActions } from '../components/Drawers/Toolbar'
import { ListPAS } from '../components/PAS/ListPAS'
import { AircraftInformationDrawer } from '../components/Projects/AircraftInformation/AircraftInformationDrawer'
import { ProjectRolePermissions } from '../domain/project-role.domain'
import { routes } from '../routes'
import { useAppSelector } from '../store'

import { Page } from './shared/Page'

export const PASPage: React.FC = () => {
    const { projectId, subjectId } = routes.PAS.useParams()
    const project = useAppSelector(selectProjectById(projectId))

    if (!project) {
        return null
    }

    return (
        <ForProjectRole permission={ProjectRolePermissions.RASListSubparts} projectId={projectId}>
            <Page logo={project.auditorLogo}>
                <ListPAS projectId={projectId} subjectId={subjectId} />
            </Page>
            <ToolbarActions>
                <ForProjectRole
                    permission={ProjectRolePermissions.AircraftInformationView}
                    projectId={projectId}
                >
                    <AircraftInformationDrawer projectId={projectId} />
                </ForProjectRole>
            </ToolbarActions>
        </ForProjectRole>
    )
}
